import { createSvgComponent } from "../../icon/createSvgComponent";
import Chevronright from "@core/__generated__/icon/figma/chevronright.svg";
export default createSvgComponent(Chevronright);